import {X_SIAM, X_APPL} from '../config/portale-config'
import {downloadFileBase64} from './utils'

export const onRequestConfig = function(config) {
  const siam = localStorage.getItem(X_SIAM)
  const appl = localStorage.getItem(X_APPL)
  //if (siam) config.headers.siam = siam;
  //if (appl) config.headers.appl = appl;
  if (siam!==undefined) 
    config.headers[X_SIAM] = siam;
  if (appl!==undefined) 
    config.headers[X_APPL] = appl;
}

export const onRequestConfigError = function(error) {
  console.log(error)
}

export const onNoServerResponse = function(error) {
  console.log(error)
}

export const onResponse = function(response) {
  //if (response.headers.siam) localStorage.setItem(X_SIAM, response.headers.siam)
  //if (response.headers.appl) localStorage.setItem(X_APPL, response.headers.appl)
  if (response.headers[X_SIAM]!==null && response.headers[X_SIAM]!==undefined) 
    localStorage.setItem(X_SIAM, response.headers[X_SIAM])
  if (response.headers[X_APPL]!==null && response.headers[X_APPL]!==undefined) 
    localStorage.setItem(X_APPL, response.headers[X_APPL])
}

export const onResponseError = function(error) {  
  switch (error.response.status) {
    case 400:
      //incongruenza cookie
        this.rootStore.errorStore.error_code = error.response.status
        this.rootStore.routingStore.push(process.env.CONTEXT_PATH + '/error')            
        break;
    case 403:
        //non autenticato (non dovrebbe capitare se c'è il TAI)
        this.rootStore.errorStore.error_code = error.response.status
        this.rootStore.routingStore.push(process.env.CONTEXT_PATH + '/error')            
        break;  
    case 401:
        this.rootStore.errorStore.error_code = error.response.status
        this.rootStore.routingStore.push(process.env.CONTEXT_PATH + '/error')
        break;
    case 409:
      //if (error.response.headers.siam) localStorage.setItem(X_SIAM, error.response.headers.siam)
      //if (error.response.headers.appl) localStorage.setItem(X_APPL, error.response.headers.appl)
      if (error.response.headers[X_SIAM]!==null && error.response.headers[X_SIAM]!==undefined) 
        localStorage.setItem(X_SIAM, error.response.headers[X_SIAM])
      if (error.response.headers[X_APPL]!==null && error.response.headers[X_APPL]!==undefined) 
        localStorage.setItem(X_APPL, error.response.headers[X_APPL])

      this.rootStore.refreshStore()
      //window.location.href = process.env.CONTEXT_PATH + '/home'
     // this.rootStore.routingStore.push(process.env.CONTEXT_PATH + '/home')            
     this.rootStore.routingStore.push(process.env.CONTEXT_PATH)            
      break;
    default:
      //TODO verificare se insieme al codice http di errore ci sia anche un messaggio valorizzato nell'header
      var msg = "Si è verificato un errore. Contattare l'assistenza.";
      var msgHeader = error.response.headers.msg;
      if(msgHeader!==undefined && msgHeader!==null && msgHeader!=="")
        msg = msgHeader;
      
      this.rootStore.uiStore.addDangerMessage({"text": msg})
      break;
  }
}

export const onResponseDownload = function(response) {
  onResponse(response);
  if(response.data) {
    if(response.data.content)
      downloadFileBase64(response.data.content, response.data.mimeType, response.data.filename);
  }
}